A privacy policy consent component of an `ApplicationQuestionnaire`.

This consists of a URL for candidates to view the privacy policy and text to prompt the candidate as to whether or not they agree.

The privacy policy consent component always defaults the available response choices for the candidate to 'Yes' and 'No'.
